





















import { Vue, Component, Prop } from 'vue-property-decorator';
import PopupBannerImageMap from '@/components/banner/popup/PopupBannerImageMap.vue';

@Component({
  components: {
    PopupBannerImageMap,
  },
})
export default class ControllerBannerImageMap extends Vue {
  @Prop({ default: '' }) private readonly imageMapData: string;

  private popupTitle: string = this.$t('BANNER_LIST_ADD_IMAGE_MAP').toString();
  private isEnablePopup: boolean = false;

  get hasImageMapData(): boolean {
    return !!this.imageMapData;
  }

  private onClickAdd(): void {
    this.enablePopup('add');
  }

  private onClickUpdate(): void {
    this.enablePopup('update');
  }

  public enablePopup(type: 'add' | 'update'): void {
    switch (type) {
      case 'add':
        this.popupTitle = this.$t('BANNER_LIST_ADD_IMAGE_MAP').toString();
        break;
      case 'update':
        this.popupTitle = this.$t('BANNER_LIST_UPDATE_IMAGE_MAP').toString();
        break;
    }

    this.isEnablePopup = true;
  }

  private onClickDelete(): void {
    this.$emit('onDelete');
    this.disablePopup();
  }

  public disablePopup(): void {
    this.isEnablePopup = false;
  }

  public onChangeData(data: { imageMap: string }): void {
    this.$emit('onSubmit', data);
  }
}
